import { Link as RouterLink } from 'react-router-dom';
import { Box, Button, Container, Flex, Heading, Image, Stack, Text } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { images } from '../data/site';
import { Eyebrow } from './Section';
const MotionBox = motion(Box);
export function Hero() {
  return <Box as="section" bg="navy.50" borderBottom="1px solid" borderColor="navy.100" overflow="hidden" data-id="element-90" data-mp="4mi3fau9loeh">
      <Container maxW="1200px" px={{
      base: 6,
      md: 8
    }} py={{
      base: 16,
      md: 28
    }} data-id="element-91" data-mp="129qvjoortvpg">
        <Flex direction={{
        base: 'column',
        lg: 'row'
      }} align="center" gap={{
        base: 12,
        lg: 16
      }} data-id="element-92" data-mp="x9upzl0fdw7s">
          <MotionBox flex="1" initial={{
          opacity: 0,
          y: 18
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          ease: 'easeOut'
        }} data-id="element-93" data-mp="sarvgui2n8e2">
            <Eyebrow data-id="element-94" data-mp="3d21tk0zn2qpb">Privately held U.S. company</Eyebrow>
            <Heading as="h1" fontSize={{
            base: '3xl',
            md: '5xl',
            lg: '6xl'
          }} lineHeight={1.08} fontWeight={600} maxW="640px" data-id="element-95" data-mp="3czfk1vt6u14g">
              Building Opportunities. Creating Long-Term Value.
            </Heading>
            <Text mt={7} fontSize={{
            base: 'md',
            md: 'lg'
          }} color="navy.500" fontWeight={300} maxW="600px" lineHeight={1.75} data-id="element-96" data-mp="3o5j4tesrxrnx">
              Futuramy Investment LLC is a privately held U.S. company focused on identifying
              business opportunities, developing strategic initiatives and building long-term value.
            </Text>
            <Stack direction={{
            base: 'column',
            sm: 'row'
          }} spacing={4} mt={10} data-id="element-97" data-mp="2qk3hsbt8fwiu">
              <Button as={RouterLink} to="/about" variant="solidNavy" size="lg" data-id="element-98" data-mp="2viy25i6ult52">
                Learn About Us
              </Button>
              <Button as={RouterLink} to="/contact" variant="outlineNavy" size="lg" data-id="element-99" data-mp="2hix40ahywzta">
                Contact Us
              </Button>
            </Stack>
          </MotionBox>

          <MotionBox flex="1" w="100%" initial={{
          opacity: 0,
          scale: 0.98
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.7,
          delay: 0.15,
          ease: 'easeOut'
        }} data-id="element-100" data-mp="s1rsao8pe6ua">
            <Box border="1px solid" borderColor="navy.100" bg="white" p={{
            base: 3,
            md: 4
          }} boxShadow="0 1px 2px rgba(13,20,29,0.04)" data-id="element-101" data-mp="icro8qfcgl98">
              <Image src={images.hero} alt="Abstract illustration of an ascending network of connected nodes representing business opportunities" w="100%" h={{
              base: '260px',
              md: '420px'
            }} objectFit="cover" loading="eager" data-id="element-102" data-mp="1ayt7t2zvvpch" />
            </Box>
          </MotionBox>
        </Flex>
      </Container>
    </Box>;
}